<template>
  <div class="modal-custom-show-result-mail-cdg">
    <div class="modal-custom-show-result-mail-cdg-content">
      <b>Résultat de l'envoi d'emails</b>
      <button
        type="button"
        class="swal2-close"
        @click="$emit('closeResultSwal')"
      >
        ×
      </button>
      <div class="mt-3">
        <div
          v-for="(error, i) in dataToShow.error"
          :key="'error-list' + i"
          class="mt-3"
        >
          <Card style="color:black">
            <template v-slot:body>
              <b class="title-sectfion">
                Liste des erreurs pour le client
                {{ error.client_name }} :</b
              >
              <div v-if="error.message" class="item-list">
                {{ error.message }}
              </div>
              <div
                v-if="
                  error.unvalid_extra_mails && error.unvalid_extra_mails.length
                "
              >
                <div class="title-list">Liste d'extras email invalides :</div>
                <div
                  class="item-list"
                  v-for="(ExMaIn, iE) in error.unvalid_extra_mails"
                  :key="'invalid-extra-mail' + iE"
                >
                  {{ ExMaIn }}
                </div>
              </div>
            </template>
          </Card>
        </div>
        <div
          v-for="(succes, iS) in dataToShow.success"
          :key="'succes-list' + iS"
          class="mt-3"
        >
          <Card style="color:black">
            <template v-slot:body>
              <b class="title-section">
                Liste des emails envoyés au client avec succès
                {{ succes.client_name }}:
              </b>
              <div v-if="succes.message" class="item-list">
                {{ succes.message }}
              </div>
              <div
                v-if="
                  succes.unvalid_extra_mails &&
                    succes.unvalid_extra_mails.length
                "
              >
                <div class="title-list">Liste d'extras email invalides : </div>
                <div
                  class="item-list"
                  v-for="(ExMaInS, iEs) in succes.unvalid_extra_mails"
                  :key="'invalid-extra-mail-succes' + iEs"
                >
                  {{ ExMaInS }}
                </div>
              </div>
              <div
                v-if="
                  succes.valid_extra_mails && succes.valid_extra_mails.length
                "
              >
                <div class="title-list">Liste d'extras email valides : </div>
                <div
                  class="item-list"
                  v-for="(ExMaVaS, iVs) in succes.valid_extra_mails"
                  :key="'valid-extra-mail-succes' + iVs"
                >
                  {{ ExMaVaS }}
                </div>
              </div>
            </template>
          </Card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataToShow: { required: true }
  },
  components: {
    Card: () => import('@/views/component/card.vue')
  }
};
</script>

<style lang="scss">
.modal-custom-show-result-mail-cdg {
  background: rgba(0, 0, 0, 0.4);
  align-items: center;
  display: flex;
  position: fixed;
  z-index: 1060;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0.625em;
  overflow-x: hidden;
  transition: background-color 0.1s;
  .modal-custom-show-result-mail-cdg-content {
    background: rgb(245, 245, 252);
    display: grid;
    margin: auto;
    animation: swal2-show 0.3s;
    position: relative;
    box-sizing: border-box;
    flex-direction: column;
    justify-content: center;
    width: 32em;
    max-width: 100%;
    padding: 1.25em;
    border: none;
    border-radius: 0.3125em;
    font-family: inherit;
    font-size: 1rem;
    .swal2-close {
      display: flex;
      cursor: pointer;
      position: absolute;
      z-index: 2;
      top: 0;
      right: 0;
      justify-content: center;
      width: 1.2em;
      height: 1.2em;
      padding: 0;
      overflow: hidden;
      transition: color 0.1s ease-out;
      border: none;
      border-radius: 0;
      outline: initial;
      background: 0 0;
      color: #ccc;
      font-family: serif;
      font-size: 2.5em;
      line-height: 1.2;
      text-transform: none;
    }
    .swal2-icon {
      display: flex;
      border-color: #f27474;
      position: relative;
      box-sizing: content-box;
      justify-content: center;
      width: 5em;
      height: 5em;
      margin: 1.25em auto 1.875em;
      border: 0.25em solid transparent;
      border-radius: 50%;
      font-family: inherit;
      line-height: 5em;
      cursor: default;
    }
    .swal2-x-mark {
      position: relative;
      flex-grow: 1;
      .swal2-x-mark-line-left {
        left: 1.0625em;
        transform: rotate(45deg);
        display: block;
        position: absolute;
        top: 2.3125em;
        width: 2.9375em;
        height: 0.3125em;
        border-radius: 0.125em;
        background-color: #f27474;
      }
      .swal2-x-mark-line-right {
        right: 1em;
        transform: rotate(-45deg);
        display: block;
        position: absolute;
        top: 2.3125em;
        width: 2.9375em;
        height: 0.3125em;
        border-radius: 0.125em;
        background-color: #f27474;
      }
    }
  }
  .item-list {
    text-align: initial;
    font-size: 11px;
  }
  .title-list {
    margin-top: 8px;
    margin-bottom: 2px;
    text-align: initial;
    font-size: 14px;
    font-weight: 700;
  }
  .title-section {
    color: #633fc2;
  }
}
</style>
